import type {
  CriteriaSection,
  FacesheetAnchorRef,
  FacesheetCriteriaRow,
} from '../types';
import { FacesheetCriteriaTable } from './FacesheetCriteriaTable';

export interface FacesheetCriteriaSectionProps {
  title: string;
  sectionId: string;
  section: CriteriaSection;
  rows: FacesheetCriteriaRow[];
  sectionRef: (element: HTMLElement | null) => void;
  getAnchorRef: FacesheetAnchorRef;
  onOpenReferences: (
    row: FacesheetCriteriaRow,
    section: CriteriaSection,
    referenceId?: string,
  ) => void;
}

export const FacesheetCriteriaSection = ({
  title,
  sectionId,
  section,
  rows,
  sectionRef,
  getAnchorRef,
  onOpenReferences,
}: FacesheetCriteriaSectionProps) => {
  return (
    <section
      ref={sectionRef}
      id={sectionId}
      tabIndex={-1}
      aria-labelledby={`${sectionId}-title`}
    >
      <h2
        id={`${sectionId}-title`}
        className="mb-5 pl-1 text-2xl leading-none font-medium text-black"
      >
        {title}
      </h2>
      <FacesheetCriteriaTable
        rows={rows}
        section={section}
        getAnchorRef={getAnchorRef}
        onOpenReferences={onOpenReferences}
      />
    </section>
  );
};
